/**
 * A fresh id for one action or one sign-in attempt.
 *
 * crypto.randomUUID is Chrome 92+ (and https-only). Android 11 phones whose
 * "Android System WebView" was never updated still run Chrome 90 — the owner's
 * own phone reports `Chrome/90.0.4430.210 ... wv` — and there a bare call
 * throws. A time-plus-random string is unique enough for one user's ids.
 *
 * Shared by idempotencyKey.js and lib/authTrace.js, which used to make its
 * Google sign-in flow id with a bare crypto.randomUUID(): on Chrome 90 that
 * threw before signInWithOAuth, so Google sign-in could not start at all
 * (BACKLOG-174-MORE-1, option (a): a fallback id).
 */
const r = () => Math.random().toString(36).slice(2);

export const randomId = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : Date.now().toString(36) + "-" + r() + r();
